export { InventoryWidget } from './InventoryWidget'